export const s = {
  page: "flex min-h-screen items-center justify-center bg-gray-50 px-6",
  card:
    "w-full max-w-md rounded-2xl border border-green-100 bg-green-50/40 p-10 text-center shadow-sm",
  iconWrap:
    "mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-green-100 text-green-600 shadow-sm",
  icon: "h-7 w-7",
  title: "mb-1 text-2xl font-extrabold text-gray-900",
  subtitle: "mb-4 text-sm font-medium text-green-700",
  body: "mb-6 text-sm text-gray-600",
  userBlock:
    "mb-6 flex flex-col items-center gap-1 text-sm text-gray-600",
  // Hexes mirror the mobile AwaitingAssociation badge (itself on StatusBadge's
  // palette): blue-50/blue-800 = new account, gray-100/gray-600 = pre-existing.
  newAccountTag:
    "mt-1 inline-flex items-center rounded-full bg-blue-50 px-2.5 py-0.5 text-xs font-semibold text-blue-800",
  existingAccountTag:
    "mt-1 inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-semibold text-gray-600",
  pollStatus:
    "mb-6 flex items-center justify-center gap-2 text-xs text-gray-500",
  pollDot:
    "h-1.5 w-1.5 animate-pulse rounded-full bg-green-500",
};
